/* eslint-disable no-open-modules-imports */

import type { FeatureGroup } from 'feature/feature-helpers';
import { SECTION } from 'feature/feature-helpers';
import { ZDFLoginScreenFeature } from 'open-modules/zdf/feature/login/zdf-login-screen';
import { t } from 'util/stdtypes';

export const loginFeatures: FeatureGroup[] = [SECTION(t('ZDF Features'), [ZDFLoginScreenFeature])];

export const loginDefaultConfig = {};
